import type {
  AuctionAlgorithm,
  AuctionsOfAuctionTileSortBy,
  AuctionStatus,
  ProductType,
  SchedulesSortBy,
  SubmissionPhase,
} from 'src/apis/transport-auction/types';
import { labelsToValues } from 'src/utils/labels-to-values';

export const auctionAlgorithmLabels: Record<AuctionAlgorithm, string> = {
  ACA: 'Ascending Clock',
  UPA: 'Uniform Price',
};

export const auctionStatusLabels: Record<AuctionStatus, string> = {
  CREATED: 'Created',
  OPEN: 'Open',
  PUBLISHED: 'Published',
  WAITING_FOR_NEXT_ROUND: 'Waiting for Next Round',
};

export const auctionsOfAuctionTileSortByValues = [
  'NETWORK_POINT_OR_BUNDLE_NAME',
  'TSO_NAME',
  'MARKETABLE_CAPACITY',
  'RUNTIME',
  'CAPACITY_CATEGORY',
  'MARKET_TRANSITION_PRICE',
] as const satisfies readonly AuctionsOfAuctionTileSortBy[];

export const schedulesSortByValues = [
  'PUBLICATION_DATE',
  'OPEN_DATE',
  'RUNTIME',
  'SLOT_INDEX',
] as const satisfies readonly SchedulesSortBy[];

export const productTypeLabels: Record<ProductType, string> = {
  YEAR: 'Year',
  QUARTER: 'Quarter',
  MONTH: 'Month',
  DAY: 'Day',
  WITHINDAY: 'Within-Day',
};

export const productTypeValues = labelsToValues(productTypeLabels);

export const scheduleStatusLabels: Record<SubmissionPhase, string> = {
  BEFORE_SUBMISSION_WINDOW: 'Waiting for Submission',
  SUBMISSION_WINDOW: 'Submission Open',
  WAITING_FOR_PUBLICATION: 'Waiting for Publication',
};

export const scheduleCountdownLabels: Record<SubmissionPhase, string> = {
  BEFORE_SUBMISSION_WINDOW: 'Submission starts in',
  SUBMISSION_WINDOW: 'Submission deadline in',
  WAITING_FOR_PUBLICATION: 'Publication in',
};
